import { TGetCryptoCurrenciesPayload } from "./types";

export namespace CryptoQuotesApi {
  export async function getCryptoCurrencies(
    payload: TGetCryptoCurrenciesPayload
  ) {
    const server = `/api/treasury/CryptoCurrencies/?symbols=${payload.symbols}`;
    let headers = new Headers({
      Authorization: `Bearer ${payload.accessToken}`,
      "content-type": "application/json",
    });
    try {
      const response = await fetch(server, {
        method: "GET",
        headers: headers,
      });

      if (response.status !== 200) {
        const errorText = await response.text();
        throw new Error(errorText);
      }
      const data = await response.json();
      return data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
